import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header/header.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformAbout"] */ "/vercel/path0/src/components/platformAbout/platformAbout.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformHero"] */ "/vercel/path0/src/components/platformHero/platformHero.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetCatalog"] */ "/vercel/path0/src/components/widgetCatalog/widgetCatalog.comp.tsx");
